var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCross = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91615 5.01023L9.80996 1.11631C10.0634 0.863024 10.0634 0.4535 9.80996 0.200216C9.55667 -0.0530669 9.14715 -0.0530669 8.89387 0.200216L4.99994 4.09414L1.10614 0.200216C0.852741 -0.0530669 0.443335 -0.0530669 0.190052 0.200216C-0.0633505 0.4535 -0.0633505 0.863024 0.190052 1.11631L4.08385 5.01023L0.190052 8.90415C-0.0633505 9.15743 -0.0633505 9.56696 0.190052 9.82024C0.316278 9.94658 0.482247 10.0101 0.648097 10.0101C0.813947 10.0101 0.979797 9.94658 1.10614 9.82024L4.99994 5.92632L8.89387 9.82024C9.02021 9.94658 9.18606 10.0101 9.35191 10.0101C9.51776 10.0101 9.68361 9.94658 9.80996 9.82024C10.0634 9.56696 10.0634 9.15743 9.80996 8.90415L5.91615 5.01023Z",
    fill: "current"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cross.7c2bc942.svg";
export { ForwardRef as ReactComponent };